'use client'

import { DisplayText, HeadlineText, JumboText, TallArrowRightIcon } from 'design-configuration/components'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import React from 'react'
export const exhibitionTransition = { duration: 0.45, ease: 'easeInOut', delay: 0.2 }

type ExhibitionHeaderProps = {
  title: string
  subtitle: string
  description: React.ReactElement
  splashHeroImage?: string
  cta?: React.ReactElement
}

export const ExhibitionHeader = ({
  title,
  subtitle,
  description,
  splashHeroImage,
  cta
}: ExhibitionHeaderProps): React.ReactElement => {
  return (
    <div className="pt-nav-bar-height">
      <div className="h-screen-minus-nav-bar relative w-full">
        <ImageWithCustomLoader
          src={splashHeroImage ?? ''}
          alt="Exhibition header"
          style={{
            objectFit: 'cover'
          }}
          className="absolute left-0 top-0 h-full w-full"
          fill
        />

        <div className="pb-2xl text-primary-inverted gap-y-sm relative z-10 flex h-full flex-col justify-between pt-[64px] sm:pt-[100px]">
          <div className="px-md">
            <JumboText className="z-50 font-medium">{title}</JumboText>
            <div className="gap-x-sm relative flex items-start">
              <DisplayText className="font-light">{subtitle}</DisplayText>
            </div>
          </div>
          <div className="px-md gap-x-md sm:bottom-2xl relative flex w-full flex-col items-end justify-center sm:absolute sm:flex-row sm:justify-between">
            <div className="flex max-w-[592px] flex-col items-start justify-center">
              <HeadlineText className="pb-md text-primary-inverted font-light">{description}</HeadlineText>
              <TallArrowRightIcon className="w-md h-md fill-primary-inverted hidden rotate-90 sm:flex" />
            </div>
            <div className="w-full sm:w-auto">{cta}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
